'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PreviewButton = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseButtons = require('@bibliocommons/base-buttons');

var _baseIcons = require('@bibliocommons/base-icons');

require('../styles/PreviewButton.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  previewURL: _react2.default.PropTypes.string
};

var PreviewButton = exports.PreviewButton = function (_BcReactComponent) {
  _inherits(PreviewButton, _BcReactComponent);

  function PreviewButton() {
    _classCallCheck(this, PreviewButton);

    return _possibleConstructorReturn(this, (PreviewButton.__proto__ || Object.getPrototypeOf(PreviewButton)).apply(this, arguments));
  }

  _createClass(PreviewButton, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _baseButtons.SecondaryButton,
        {
          className: 'cp-user-list-preview-button',
          tagName: 'a',
          target: '_blank',
          rel: 'noopener noreferrer',
          href: this.props.previewURL,
          'data-test-id': 'preview-button' },
        _react2.default.createElement(_baseIcons.Eye, null),
        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'user_list_preview' })
      );
    }
  }]);

  return PreviewButton;
}(_baseBcReactComponent2.default);

PreviewButton.propTypes = propTypes;

exports.default = PreviewButton;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/preview-button/components/PreviewButton.component.js
// module id = 1326
// module chunks = 0